var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid p-0 m-0"},[_c('Header'),_c('ListView',{attrs:{"list":_vm.$store.state.schedule.checkingList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }